import React from "react";
import { connect } from "react-redux";
import AjaxTableDisplay from "../../../misc/AjaxTableDisplay";
import h from "../../../../helpers";

import type { FlowItem } from "../../../../types/flowTypes";
import type { MapStateToProps } from "react-redux";

import buildSimpleColumns from "../../../../helpers/buildSimpleColumns";

type Props = {
    // Passed In
    flowItemId: ?number,
    // Redux
    flowItem: ?FlowItem,
};

type State = {
    loading: boolean,
    extendedLoading: boolean,
    error: boolean,
    isResultsLoaded: boolean,
    records: any,
    recordCount: ?any,
    columns: Array<any>,
    order: string,
    orderBy: string,
    page: number,
    rowsPerPage: number,
};

class FlowItemQADisplay extends React.Component<Props, State> {
    constructor() {
        super();
        this.state = {
            loading: false,
            extendedLoading: false,
            error: false,
            isResultsLoaded: false,
            records: [],
            recordCount: null,
            columns: [],
            order: "desc",
            orderBy: "",
            page: 0,
            rowsPerPage: 15,
        };
    }

    componentDidMount() {
        const { flowItemId } = this.props;

        if (flowItemId) {
            this.setState({ loading: true });

            fetch(`/FlowItemReports/Count/${flowItemId}`, { credentials: "same-origin" })
                .then(h.checkStatus)
                .then(h.toJson)
                .then(recordCount => {
                    this.setState({ recordCount }, () => this.fetchData());
                    this.setState({ loading: false });
                })
                .catch(error => {
                    this.setState({ error: true, loading: false });
                    h.errorSilent("Couldn't load Flow Item Preview Results Modal data", error);
                });
        }
    }

    fetchData = () => {
        const { flowItemId } = this.props;
        const { recordCount } = this.state;

        if (recordCount == 0) {
            this.setState({
                records: [],
                loading: false,
                extendedLoading: false,
                isResultsLoaded: true,
                error: false,
            });
        } else if (recordCount && recordCount > 0 && flowItemId) {
            fetch(`/FlowItemReports/QA/${flowItemId.toString()}`, { credentials: "same-origin" })
                .then(h.checkStatus)
                .then(h.toJson)
                .then(records => {
                    this.setState(
                        { records, loading: false, extendedLoading: false, isResultsLoaded: true, error: false },
                        () => this.buildColumns()
                    );
                })
                .catch(error => {
                    this.setState({ error: true, loading: false });
                    h.errorSilent("Couldn't load Flow Item Preview Results Modal records", error);
                });

            return;
        }

        this.setState({ records: [], loading: false, extendedLoading: false, error: false }, () => this.buildColumns());
    };

    buildColumns = () => {
        const { records } = this.state;

        const columns = this.applyFlowQAColumnHack(buildSimpleColumns(records));
        this.setState({ columns });
    };

    applyFlowQAColumnHack = columns => {
        const { flowItemId } = this.props;

        if (flowItemId) {
            const shouldDoHack = `/FlowItemReports/QA/${flowItemId.toString()}`;
            if (!shouldDoHack || columns == null) {
                return columns;
            }

            // Always move "Node" to the front of the list
            // Generally we're getting the order of columns from the DB, but numeric-only columns seem to
            // introduce a problemm.. probably need a more robust fix.
            const nodeColumns = columns.filter(x => x.id == "Node");
            if (nodeColumns.length == 1) {
                const nodeItem = nodeColumns[0];
                columns = columns.filter(x => x.id != "Node");
                columns.unshift(nodeItem);
            }
            return columns;
        }
    };

    handleRequestSort = (event, property) => {
        this.setState(
            this.state.order === "asc" ? { order: "desc", orderBy: property } : { order: "asc", orderBy: property }
        );
    };

    render() {
        const { flowItem, flowItemId } = this.props;
        if (flowItem == null || flowItemId == null) {
            return null;
        }

        const countUrl = "/FlowItemReports/Count/" + flowItemId;
        const dataUrl = "/FlowItemReports/QA/" + flowItemId;

        const belowErrorMessage = null;
        const header = null;
        const footer = "";
        return (
            <AjaxTableDisplay
                countUrl={countUrl}
                dataUrl={dataUrl}
                header={header}
                footer={footer}
                belowErrorMessage={belowErrorMessage}
                showRecordCount
                downloadUrl={null}
            />
        );
    }
}

const mapStateToProps: MapStateToProps<*, *, *> = (state, ownProps) => ({
    flowItem: state.flowItems.byId[ownProps.flowItemId],
});
const mapDispatchToProps = null;
const FlowItemQADisplayC = connect(mapStateToProps, mapDispatchToProps)(FlowItemQADisplay);

export default FlowItemQADisplayC;
